import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useState, useEffect } from 'react';
import { Handshake } from 'lucide-react';
import { Layout } from '@/components/layout/Layout';
import { Header } from '@/components/layout/header/Header';
import { PartnerCard } from '@/components/partners/PartnerCard';
import { PartnerCardSkeleton } from '@/components/partners/PartnerCardSkeleton';
import { partnersData } from '@/components/partners/partnersData';

export default function Partners() {
  useLanguage();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading for smooth skeleton transition
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Layout fixedSidebar={true}>
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Ícone do menu lateral no chip que o Header renderiza antes do título */}
        <Header
          title={translateInterfaceText("Parceiros Oficiais")}
          icon={<Handshake className="h-[18px] w-[18px] text-[#2D6CF6]" strokeWidth={2} />}
        />
        
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto p-6 max-w-6xl">
            {/* Partners Grid */}
            {isLoading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
                {Array.from({ length: 8 }).map((_, index) => (
                  <PartnerCardSkeleton key={index} />
                ))}
              </div>
            ) : partnersData.length === 0 ? (
              /* Empty State */
              <div className="flex flex-col items-center justify-center py-20">
                <p className="text-[16px] text-[#637083]">
                  {translateInterfaceText("Em breve novos parceiros estarão disponíveis.")}</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-7">
                {partnersData.map((partner, index) => (
                  <PartnerCard 
                    key={index}
                    logo={partner.logo}
                    name={partner.name}
                    description={partner.description}
                    category={partner.category}
                    url={partner.url}
                    index={index}
                  />
                ))}
              </div>
            )}
          </div>
        </main>
      </div>
    </Layout>
  );
}
